import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/delete_icon.png'
import _imports_1 from '../../images/ic_upload_pictures.png'
import _imports_2 from '../../images/img_top-up_success.png'


const _withScopeId = n => (_pushScopeId("data-v-ac5ad080"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "create-image" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "titleText" }, "凭证上传")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "info"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tipInfo" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, "上传有效凭证图片，更易申诉成功，至多可传3张")
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  style: {"margin-top":"12px"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "custom-upload",
  style: {"margin-top":"12px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "上传图片"
  }),
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","margin-top":"12px","font-weight":"400","color":"#9D9D9D"} }, "上传图片")
], -1))
const _hoisted_11 = {
  key: 1,
  class: "info",
  style: {"margin-top":"86px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16px","font-weight":"500","color":"#000000","margin-top":"22px"} }, "您已成功上传 ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"400","color":"#9D9D9D","font-size":"14px","margin-top":"12px"} }, "请等待电脑端同步上传结果", -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "btn-box"
}

import { watch, onMounted, reactive, ref } from "vue";
import type { UnwrapRef } from "vue";
import dayjs, { Dayjs } from 'dayjs';
import html2canvas from 'html2canvas';
import axios from 'axios';
import { message } from "ant-design-vue"
import {extractUrlQueryParams, fileToBase64WithName} from '@/utils/index'


interface Obj {
  [key: string]: any
}
interface FormState {
  layout: "horizontal" | "vertical" | "inline";
  name: string;
  phone: string;
  idCard: string;
  area: string;
  birthday: Dayjs;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MarginPicture',
  setup(__props) {

const formState: UnwrapRef<FormState> = reactive({
  layout: "horizontal",
  name: "",
  phone: "",
  idCard: "",
  area: "",
  birthday: dayjs('2000-01-01')
});
const orderInfo = ref<Obj>({})
const browserType = ref(false)
const body = ref<any>(null)
function getBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};
const fileList = ref([]as string[]);
const successFlag = ref(false)
onMounted(() => {
  document.title = '视塔ERP'
})
const loadingUp = ref(false);


// 使用示例
// const url = "http://example.com/path/to/page?param1=value1&param2=value2";
const removeSuffixIfPresent = (str:any) =>  {
  // 判断字符串是否以 '_120x120.jpg' 结尾
  if (str.endsWith('_120x120.jpg')) {
    // 去除结尾的 '_120x120.jpg'
    return str.slice(0, -'_120x120.jpg'.length);
  }else{
    return str;

  }
}
const submit = async () => {
  if(!fileList.value||!fileList.value.length){
    return
  }
  let arr:any = []
  fileList.value.forEach(item=>{
    if(item){
      arr.push(removeSuffixIfPresent(item))
    }
  })
  let imageUrl = arr.join(',')
  const params = extractUrlQueryParams(window.location.href);
  const postData = new FormData()
  postData.append("shopId", params.shopId)
  postData.append("imageUrl", imageUrl)
  postData.append("marginId", params.marginId)
  
  axios.post('https://api-erp.yaofangwang.com/common.handle.uploadMarginAppealImages', postData)
    .then((response) => {
      if (response.data?.code == 1) {
        successFlag.value = true;
      }else {
        message.error(response.data?.msg)
      }
    })
    .catch((error) => {
      message.error(error.message)
    });
}
const removePic = (file:any)=>{
  const arr =  fileList.value.filter(item=>{return item != file })
  fileList.value = JSON.parse(JSON.stringify(arr))
}

const handleFileChange= async(e:any) =>{
  const file = e.target.files[0];
  if (!file) return;
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    alert('只能上传jpg或png格式的图片！');
    return;
  }
  const isLt2M = file.size / 1024 / 1024 < 5;
  if (!isLt2M) {
    alert('图片大小不能超过5MB！');
    return;
  }
  loadingUp.value = true; 
  try {
    const formData = new FormData();
    // formData.append('file', file); // 假设服务器接口期望接收名为'file'的字段
    // 发起POST请求进行文件上传
    const params = extractUrlQueryParams(window.location.href);
    formData.append("ssid", params.ssid)

    const {fileName , base64} = await fileToBase64WithName(file)
  
    formData.append('fileName',fileName);
    formData.append("fileBase64",base64)
    const response = await axios.post('https://api-erp.yaofangwang.com/common.handle.uploadForH5', formData, {
      headers: {
        // 'Content-Type': 'multipart/form-data', // 设置正确的Content-Type
      },
    });
    if (response.status === 200) {
      fileList.value.push(response.data.result)
      message.success('上传成功')
    } else {
      message.error('上传失败,请重试');
    }
    loadingUp.value = false; 
  } catch (error) {
    message.error('上传失败,请重试');
    loadingUp.value = false; 
  }
}


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "mobile-content",
    ref: (ref) => (body.value = ref)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (!successFlag.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            (fileList.value&&fileList.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      style: {"position":"relative","width":"100%","background-color":"#F8F8F8"}
                    }, [
                      item
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("img", {
                              style: {"height":"142px"},
                              src: 'https://c1.yaofangwang.net/'+item
                            }, null, 8, _hoisted_7),
                            _createElementVNode("img", {
                              src: _imports_0,
                              style: {"width":"24px","position":"absolute","right":"0","top":"0","cursor":"pointer"},
                              alt: "",
                              onClick: ($event: any) => (removePic(item))
                            }, null, 8, _hoisted_8)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (fileList.value.length < 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("input", {
                    type: "file",
                    id: "avatar",
                    name: "avatar",
                    accept: "image/png, image/jpeg",
                    onChange: handleFileChange
                  }, null, 32),
                  _hoisted_10
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15)),
      (!successFlag.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: submit,
              loading: loadingUp.value,
              class: _normalizeClass(!fileList.value.length?'hidTransf':'')
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            }, 8, ["loading", "class"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})